import { render, staticRenderFns } from "./PlanProfilePage.vue?vue&type=template&id=217b2237&scoped=true&"
import script from "./PlanProfilePage.vue?vue&type=script&lang=js&"
export * from "./PlanProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./PlanProfilePage.vue?vue&type=style&index=0&id=217b2237&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217b2237",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader,VTab,VTabs})
